const rule = {
    tagname: [{
        required: true,
        type: 'string',
        message: '请填写分类名称',
        trigger: 'blur'
    }],
};

export default rule;


// WEBPACK FOOTER //
// ./src/validateRule/company/tagType.js